export const GROUP_NAMES = ["Tilley-Lenders", "Tilley-Brokers"];

export const getErrorMessage = (err) => {
  if (!err) return "An unexpected error occurred.";
  if (typeof err === "string") return err;

  const axiosError = err?.error || err;
  const status = axiosError?.response?.status;
  const responseData = axiosError?.response?.data;

  let message = "";
  if (typeof responseData === "string") {
    message = responseData;
  } else if (responseData && typeof responseData === "object") {
    message = responseData.detail || responseData.message || "";
  }

  if (!message) {
    message = err?.detail || err?.message || axiosError?.message || "";
  }

  if (status === 500 || !status) {
    const isTooLong = message.length > 200;
    const hasStack = message.includes("\n") || message.toLowerCase().includes("stack");

    if (isTooLong || hasStack) {
      return "An internal server error occurred. Please contact support.";
    }
  }

  if (message.includes("status code 500")) {
    return "Server error. Please try again later.";
  }

  return message || "An unexpected error occurred. Please try again.";
};
